import React, { useState, useEffect } from "react";
import "./../../assets/styles/custom/components/Header.scss";
import firebase from "../../Firebase/firebase";
import { useQuery } from "@apollo/client";
import { MainDashboardQuery } from "../MainDashboard/Queries/MainDashoardQuery";
const Header = () => {
  const [users, setusers] = useState({});
  //new start
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);
  const { data } = useQuery(MainDashboardQuery, {
    variables: { id: users?.token?.claims?.user_id },
  });
  if (window.location.pathname.split("/")[2] === "data-admin" || "manager") {
    return (
      <div className="header-container">
        <div id="Group_49">
          <img
            src={data?.aatmsv4_register[0]?.client?.logo}
            style={{ marginBottom: "20px" }}
            alt=""
            height="80px"
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="header-container">
        <div className="logo-container"></div>
      </div>
    );
  }
};

export default Header;
